import {
  useToggleOnlineHeartbeatMutation,
  ToggleOnlineHeartbeatMutationResult
} from 'generated/schemaTypes';
import { useGetIdentity } from 'contexts/IdentityProvider';

const useToggleOnline = (): [
  (goOnline: boolean) => void,
  ToggleOnlineHeartbeatMutationResult
] => {
  const identity = useGetIdentity();
  const userID = identity?.user?.userID;

  const [doToggle, result] = useToggleOnlineHeartbeatMutation();

  const toggle = (goOnline: boolean): void => {
    if (!userID) {
      return;
    }

    const variables = goOnline ? { userID } : { userID, ttl: 0 };
    doToggle({ variables });
  };

  return [toggle, result];
};

export default useToggleOnline;
